/**
 * Extracted from `components/assessment-structure/band-scale.tsx` so Fast Refresh can preserve that file's
 * component state. A component file that also exports plain values makes
 * React remount the whole tree on every edit; these values have no JSX in
 * them, so they belong beside the component rather than inside it.
 */

import {
  D_INDEX_ADEQUATE_MIN,
  D_INDEX_STRONG_MIN,
} from "@/lib/discrimination"
import { PBI_ADEQUATE_MIN, PBI_STRONG_MIN } from "@/lib/pbi-bands"
import { REUSE_OVERUSED_AT } from "@/lib/question-reuse"

export interface Band {
  label: string
  /** Lower bound, in the scale's own units. The first band starts at zero. */
  from: number
  tone: "success" | "danger" | "neutral" | "warning"
}

export const DIFFICULTY_SCALE: readonly Band[] = [
  { label: "Hard", from: 0, tone: "neutral" },
  { label: "Medium", from: 0.45, tone: "neutral" },
  { label: "Easy", from: 0.72, tone: "neutral" },
]

export const PBI_SCALE: readonly Band[] = [
  { label: "Doesn't separate", from: 0, tone: "danger" },
  { label: "Separates somewhat", from: PBI_ADEQUATE_MIN, tone: "neutral" },
  { label: "Separates well", from: PBI_STRONG_MIN, tone: "neutral" },
]

export const D_INDEX_SCALE: readonly Band[] = [
  { label: "Doesn't separate", from: 0, tone: "danger" },
  { label: "Separates somewhat", from: D_INDEX_ADEQUATE_MIN, tone: "neutral" },
  { label: "Separates well", from: D_INDEX_STRONG_MIN, tone: "neutral" },
]

export const USAGE_SCALE: readonly Band[] = [
  { label: "Unused", from: 0, tone: "neutral" },
  { label: "In rotation", from: 1, tone: "neutral" },
  { label: "Overused", from: REUSE_OVERUSED_AT, tone: "danger" },
]

export function percent(value: number): string {
  return `${Math.round(value * 100)}%`
}
